import React, { Fragment } from "react";
import _ from "lodash";

import {
  SideLabelTextAreaWithRefInput,
  SideLabelPercentWithRefInput
} from "../../FormSectionComponents";

class PrepaymentTermsNone extends React.Component {
  render() {
    const { isEditing } = this.props;

    return (
      <>
        <SideLabelPercentWithRefInput
          label="Exit Fee"
          hasBorder
          placeholder="Exit Fee"
          fieldName="prepaymentTerms.exitFee"
          isDisabled={!isEditing}
        />
        <SideLabelTextAreaWithRefInput
          label="Lockout Period"
          hasBorder
          placeholder="Lockout Period"
          fieldName="prepaymentTerms.lockoutPeriod"
          isDisabled={!isEditing}
        />
        <SideLabelTextAreaWithRefInput
          label="Notice Period"
          hasBorder
          placeholder="Notice Period"
          fieldName="prepaymentTerms.noticePeriod"
          isDisabled={!isEditing}
        />
        <SideLabelTextAreaWithRefInput
          label="Other"
          placeholder="Other"
          fieldName="prepaymentTerms.other"
          isDisabled={!isEditing}
        />
      </>
    );
  }
}
export default PrepaymentTermsNone;
